<template>
    <div>
        <b-card>
            <div slot="header">
                <i class="fa fa-list-ul" aria-hidden="true"></i>
                    News list
                <div class="card-header-actions">
                    <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
                    <small class="text-muted">docs</small>
                    </a>
                </div>
            </div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="isError"> {{ errorMessage }} </alert-fail>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="currentPage"
                          :per-page="numberPerPage"
                          class="table-news"
                          tbody-class="tbody" hover
                          thead-tr-class="thead-news"
                          @row-clicked="viewDetails"
                          selectable
                          selectedVariant="single"
                          :fields="fields"
                          :items="list">
                          <template slot="thumbnail" slot-scope="row">
                            <img class="thumbnail" :src="row.item.thumbnail" alt="Thumbnail">
                          </template>
                          <template slot="topic" slot-scope="row">
                            {{ row.item.title }}
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                    <b-col>
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="numberPerPage"
                        class="my-0"
                        ></b-pagination>
                    </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import AlertFail from '../../components/alert/AlertFail';
import { timestampToDate } from '../../assets/utils/formatter';

export default {
  data () {
    return {
      isBusy: false,
      numberPerPage: 10,
      fields: [
        { key: 'thumbnail' },
        { key: 'createdDate' },
        { key: 'type' },
        { key: 'title' }
      ],
      list: [],
      isError: false,
      errorMessage: '',
      currentPage: 1,
      totalRows: 1
    };
  },
  methods: {
    viewDetails (e) {
      this.$router.push({ name: 'news-details', params: { id: e.id } });
    },
    errorHandler (error) {
      this.isError = true;
      this.errorMessage = error.response ? error.response.data : error.message;
    }
  },
  mounted () {
    this.isBusy = true;
    this.axios.get(process.env.VUE_APP_URL_MQDC_API + '/news?type=all', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(response => {
        const data = response.data.data;
        for (const news of data) {
          if (news.id) {
            this.list.push({
              id: news.id,
              createdDate: timestampToDate(news.createdAt.timestamp),
              thumbnail: news.thumbnail,
              title: news.title,
              type: news.type
            });
          }
        }
        this.totalRows = this.list.length;
        this.isBusy = false;
      })
      .catch(error => {
        console.log(error);
        this.errorHandler(error);
      });
  },
  components: {
    AlertFail
  }
};
</script>

<style scoped>
    .table-news{
        color: #73818f;
    }
    .table-news>thead{
        font-size: 10px;
    }
    .thumbnail{
        max-width: 100px;
    }
</style>

<style>
    .thead-news{
        white-space: nowrap;
    }
</style>
